import * as React from 'react';
import classnames from 'classnames';
import ChevronSVG from '../../../../../../../../../../../images/svg/icons8-expand-arrow';
import { ISingleSelectClosedPropsDerivedFromItemsList, makeSingleSelectInPopover, } from '../../../../../../../../../../global/single-select/make-single-select-in-popover';
import './organization-select-trigger.scss';

interface IOrganizationSelectTriggerProps extends ISingleSelectClosedPropsDerivedFromItemsList {
    className?: string;
}

const OrganizationSelectTrigger = React.forwardRef((props: IOrganizationSelectTriggerProps, ref: React.Ref<HTMLDivElement>) => {
    const { name, isOpen, className } = props;

    return (
        <div
            className={classnames('organization-select-trigger', className, { 'organization-select-trigger--open': isOpen })}
            ref={ref}
        >
            <input type='text' value={name || ''} readOnly className='organization-select-trigger__input' />
            <span className={classnames('organization-select-trigger__chevron', { 'organization-select-trigger__chevron--open': isOpen })}>
                <ChevronSVG />
            </span>
        </div>
    );
});

const OrganizationSelectInput = makeSingleSelectInPopover(OrganizationSelectTrigger);

export { OrganizationSelectInput, OrganizationSelectTrigger };